import { createSlice } from "@reduxjs/toolkit";

const productSlice = createSlice({
  name: "product",
  initialState: {
    allProducts: {}, // Store API response here
  },
  reducers: {
    setproduct(state, action) {
      state.allProducts = action.payload; // Update state correctly
    },
  },
});

export const { setproduct } = productSlice.actions;
export default productSlice.reducer;
